export default [
  {
    path: "/d1066d309f40e0ddb5db6eef",
    children: [
      {
        path: "d0f0f1c624ee1cd45db70873",
        component: () => import("@/views/traits-type/index.vue"),
        name: "trait-types",
        meta: {
          authRequired: true,
          title: "Trait Types",
        },
      },
      {
        path: "VAq1Hd0ec4034c84b98b3ca0d5052yKlahoF",
        component: () => import("@/views/traits-type/create.vue"),
        name: "create-trait-type",
        meta: {
          authRequired: true,
          title: "Create Trait Type",
        //   acc: ["y94175"],
        },
      },
      {
        path: "ZasDd176b4eda65d5719c766a3a3dVS1/:id?",
        component: () => import("@/views/traits-type/view.vue"),
        name: "view-trait-type",
        meta: {
          authRequired: true,
          title: "View Trait Type",
        //   acc: ["y62177"],
          breadcrumb:{
                route: 'trait-types'
            
            },
        },
      },

      {
        path: "VAq1Hd1f05e3d53925147410afb3dyKQLF/:id",
        component: () => import("@/views/traits-type/edit.vue"),
        name: "update-trait-type",
        meta: {
          authRequired: true,
          title: "Update Trait Type",
          acc: ["y42858"],
          breadcrumb:{
                route: 'trait-types'
            
            },
        },
      },
    ],
  },
];
